module.exports = __webpack_public_path__ + "static/image3-d78c6dee303460b3f325018423d0e435.jpg";